import { render, staticRenderFns } from "./purchaseReturns.vue?vue&type=template&id=59fd8a2c&scoped=true"
import script from "./purchaseReturns.vue?vue&type=script&lang=js"
export * from "./purchaseReturns.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturns.vue?vue&type=style&index=0&id=59fd8a2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd8a2c",
  null
  
)

export default component.exports